import { Grid, Typography } from '@material-ui/core'
import { CrudForm, Snackbar, useEntityManager } from 'elentari'
import { TextField } from 'final-form-material-ui'
import React, { Fragment, useState } from 'react'
import { Field } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'
import Checkbox from '../../components/Checkbox'
import NumberFormatInput from '../../components/NumberFormatInput'
import { formatCurrency } from '../../utils/Formatter'
import { getOnlyDigits } from '../../utils/Utils'
import { RiscoAutocomplete } from '../Riscos/components/RiscoAutocomplete'
import { cenarioRepository } from './CenarioRepository'
import { validateForm } from './validation'
import { validateValor } from './utils'

export const CenarioForm = ({ ...props }) => {
  const [mensagem, setMessage] = useState('')

  const entityManager = useEntityManager({ repository: cenarioRepository })

  const handleSubmit = async data => {
    delete data.risco

    const response = await entityManager.onSubmit({
      ...data,
      valorInicial: validateValor(data.valorInicial),
      valorFinal: validateValor(data.valorFinal),
      limiteValorKmm: Number(data.limiteValorKmm),
      prazoRenovacao:
        typeof data.prazoRenovacao === 'string'
          ? Number(getOnlyDigits(data.prazoRenovacao))
          : data.prazoRenovacao
    })

    if (!response.ok) {
      setMessage(
        response.message ?? 'Ocorreu algum erro ao tentar salvar o registro.'
      )
      return
    }
  }

  const handleChangeValues = ({ values, change }) => {
    if (!values?.valorFinal && !values?.valorInicial) {
      return change('descricao', null)
    }

    if (!values?.valorFinal) {
      return change(
        'descricao',
        `Acima de ${formatCurrency(values.valorInicial)}`
      )
    }

    change('descricao', `Até ${formatCurrency(values.valorFinal)}`)
  }

  return (
    <Fragment>
      <CrudForm
        {...props}
        {...entityManager}
        validate={validateForm}
        onSubmit={handleSubmit}
        withPaper
      >
        {({ values, form: { change }, ...rest }) => (
          <Grid container spacing={2}>
            <OnChange name="valorInicial">
              {() => handleChangeValues({ values, change })}
            </OnChange>
            <OnChange name="valorFinal">
              {() => handleChangeValues({ values, change })}
            </OnChange>
            <Grid item xs={12} md={6}>
              <Field
                fullWidth
                name="descricao"
                label="Descrição do Cenário"
                component={TextField}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <NumberFormatInput
                label="Valor Inicial"
                name="valorInicial"
                fullWidth
                allowNull
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <NumberFormatInput
                label="Valor Final"
                name="valorFinal"
                fullWidth
                allowNull
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                fullWidth
                name="riscoId"
                label="Risco"
                component={RiscoAutocomplete}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <NumberFormatInput
                label="Limite de Valor no KMM"
                name="limiteValorKmm"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Field
                fullWidth
                name="prazoRenovacao"
                label="Prazo de Renovação (em dias)"
                component={TextField}
                type="number"
                inputProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography>Autonomia</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Field
                        fullWidth
                        name="autonomiaAuxiliar"
                        label="Auxiliar"
                        defaultValue={false}
                        component={Checkbox}
                        type="checkbox"
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Field
                        fullWidth
                        name="autonomiaAssistente"
                        label="Assistente"
                        defaultValue={false}
                        component={Checkbox}
                        type="checkbox"
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Field
                        fullWidth
                        name="autonomiaAdministrador"
                        label="Administrador"
                        defaultValue={false}
                        component={Checkbox}
                        type="checkbox"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography>Tipos de Liberação</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Field
                        fullWidth
                        name="liberadoAutomacao"
                        label="Automação"
                        defaultValue={false}
                        component={Checkbox}
                        type="checkbox"
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Field
                        fullWidth
                        name="liberadoCentralCadastros"
                        label="Central de Cadastros"
                        defaultValue={false}
                        component={Checkbox}
                        type="checkbox"
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Field
                        fullWidth
                        name="liberadoGestor"
                        label="Autorização Gestor"
                        defaultValue={false}
                        component={Checkbox}
                        type="checkbox"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </CrudForm>
      <Snackbar
        autoHideDuration={6000}
        message={mensagem}
        onClose={() => {
          setMessage('')
        }}
      />
    </Fragment>
  )
}
